import { Box } from '@mui/material/';
import Typography from '@mui/material/Typography';
import { Button } from 'primereact/button';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import NewSupportPage from './NewSupportPage';

function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

const marks = [
    {
        value: 0,
        label: '$1.234',
    },
    {
        value: 50,
        label: '$1.863',
    },
    {
        value: 100,
        label: '$2.863',
    },
];

const schain = [
    {
        node: 1,
        domain: 'example.com'
    },
    {
        node: 2,
        domain: 'unruly.com'
    }
]
export default function AddTicket() {
    const [value, setValue] = React.useState(0);
    const [progress, setProgress] = React.useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const [demandAlignment, setDemandAlignment] = useState([]);

    const paginatorLeft = <Button type="button" icon="pi pi-refresh" text />;
    const paginatorRight = <Button type="button" icon="pi pi-download" text />;

    useEffect(() => {
        //ApiData.getSupply().then(data => setDemandAlignment(data));
    }, []);

    const demandName = () => {
        return (
            <div>
                <div className="supplyPartner flex justify-content-center">{demandAlignment[0].demandName}</div>
            </div>
        )
    }

    const supplyName = () => {
        return (
            <div>
                <div className="supplyPartner flex justify-content-center">{demandAlignment[0].supplyName}</div>
            </div>
        )
    }

    return (
        <Box sx={{ width: '100%', padding: '1rem' }} className="popupContent">
           <NewSupportPage></NewSupportPage> 
        </Box>
    );
}